define([
	"dojo/aspect",
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi",
	"csi/_base/modules",
	"csi/_base/underscore",
	"csi/config",
	"csi/comm/PostRequest",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/enums",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/widget/ErrorText",
	"csi/xml",
	"csi/xml/Search",
	"csi/xml/Query",
	"csi/sessionConstants",
	"csi/def/AddPath",
	"./CopySupplierRequestRightWidget",
	"Sourcing"

], function(aspect, array, declare, lang, when, csi, modules, _, config, PostRequest, def, Action, Field, Relationship, ViewRef, enums, html, locale, reflection, csiStore, Names, ErrorText, xml, Search, Query, sessionConstants, AddPath, CopySupplierRequestRightWidget, Sourcing) {

	const _MessageText = declare(ErrorText, {
		infoResource: "SupplierRequest_ExistingValuesMayCarry",

		onInfoMessage: function() {
			if (this.domNode) {
				html.clear(this.domNode, true);

				const inputWidgetValue = this.inputWidget.get("value");
				if (inputWidgetValue == "QuoteSampleOption:PreviousSetup") {
					this.inherited(arguments);
				}
			}
		},

		postCreate: function() {
			const self = this;

			this.inherited(arguments);
			this.own(aspect.after(this.inputWidget, "onChange", function() {
				self.onInfoMessage();
			}));
		}
	})

	return declare(null, {

		TEMPLATE: "SRTemplate",
		SUPPLIERS: "SRSuppliers",
		TEMPLATE_DP: "SRDPTemplate",
		NOTIFY_GROUPS: "SRNotifyGroups",
		INSPIRATION_STYLE_TYPE: "InspirationStyleType",
		SUBMIT_TO_WORKFLOW: "SubmitQuotesToWF",
		QUOTES: "IncludeQuotes",
		REQUEST_TYPE: "RequestType",
		SAMPLES: "IncludeSamples",
		SAMPLETYPE: "SampleType",
		STYLE: "Style",
		MATERIAL: "Material",
		SUBTYPE: "Subtype",
		SUPPLIER_FACTORIES: "SRSupplierFactories",
		originalProductStore: null,
		accessibleSupplierSources: null,
		currentCreationLevel: null,

		quoteSampleOptionPrevious: "QuoteSampleOption:PreviousSetup",
		quoteSampleOptionTemplate: "QuoteSampleOption:ByTemplate",
		PRODUCT_SOURCE_CREATION_LEVEL: "ProductSourceCreationLevel",

		TEMPLATE_VALUE: csi.EMPTY_URL,

		_resolveView: function() {
			// summary: add field for request template if creating new request and there are templates
			const templates = Sourcing.getLibraryNode().RequestTemplates;
			if (templates.length && (!this.getViewNode() || this.isCopy())) {
				const f = this.defView.getField(this.TEMPLATE);
				if (f) {
					f.idParameter = "TemplateURL";
					f.m_onChange = "_onChangeTemplate";
				}
			} else {
				this.defView.removeField("SRTemplate");
			}

			if (this.defView.getSource().m_action.m_id != "Edit") {
				this.insertFieldIfNotExist(this._productType() + "s", 3, {
					m_typeControl: def.FIELD_MULTI_SELECT,
					m_onChange: "_onChangeProducts",
					m_bRequired: (this._productType() === "FoodSKU"),
				});
			}

			if (modules.hasModule("Specification")) {
				this.insertFieldIfNotExist(this.TEMPLATE_DP, this._productType() + "s", {
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_onChange: "_onChangeDPTemplate",
				});
			}

			this.insertFieldIfNotExist(this.SUPPLIERS, 3, {
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_onChange: "_onChangeSuppliersOrFactories",
				omitFromReport: true,
			});

			this.addDefaultValue("Requester", sessionConstants.userUrl);

			// if there is an inspiration style type field, make it read-only
			f = this.defView.getField(this.INSPIRATION_STYLE_TYPE);
			if (f)
				f.m_right = xml.RIGHT_NONE;

			this.inherited(arguments);

			this.insertFieldIfNotExist(this.SUBTYPE, 1, {
				m_bRequired: true,
				m_onChange: "_onChangeSubtype",
			});
			this.insertFieldIfNotExist(this.SUPPLIER_FACTORIES, 4, {
				m_onChange: "_onChangeSuppliersOrFactories",
				// prevent the Form for triggering add/remove SupplierFactories operation from the aggregateStore
				omitFromReport: true,
			});

			// Add "Include Quotes / Samples" widget
			this.rightWidgetClass = CopySupplierRequestRightWidget;

			if (this.isCopy()) {
				this.insertField(lang.mixin(new Field(), {
					m_id: this.QUOTES,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_onChange: "_onChangeIncludeQuotes",
					messageClass: _MessageText
				}), 3);

				this.insertField(lang.mixin(new Field(), {
					m_id: this.SAMPLES,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_onChange: "_onChangeIncludeSamples",
				}), 4);

				this.insertField(lang.mixin(new Field(), {
					m_id: this.SAMPLETYPE,
					m_typeControl: def.FIELD_FILTERING_SELECT
				}), 5);

				this.setFieldDisabled(this.SAMPLETYPE, true);

				this.setFieldValue(this.QUOTES, 1);
				this.setFieldValue(this.SAMPLES, 1);
				this.setFieldDisabled(this.QUOTES, true);
				this.setFieldDisabled(this.SAMPLES, true);
			}
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			// summary: if field is for LineItem or Supplier, then add SelectAll option
			const name = field.getControlName();
			if (name == "Foods") {
				return this.getProductsStore("Food");
			} else if (name == "FoodSKUs") {
				return this.getProductsStore("FoodSKU");
			} else if (name == "FormulatedMaterials") {
				return this.getProductsStore("FormulatedMaterial");
			} else if (name == "Styles" || name == "Materials") {
				// optimization: do not query for all styles or materials when style or material are set
				const fixedValue = this.getFixedValue(name);
				if (fixedValue) {
					const fixedValueNode = this.getCache().getNode(fixedValue);
					return new Names({
						data: [csiStore.nameObject(fixedValueNode)]
					});
				}
				return name == "Styles" ? this.getProductsStore("Style") : this.getProductsStore("Material");
			} else if (name == this.QUOTES || name == this.SAMPLES) {
				return enums.getStore("QuoteSampleOption", null, null, true);
			} else if (name == this.SAMPLETYPE) {
				return enums.getStore(this.SAMPLETYPE, null, null, true);
			} else if (name == this.TEMPLATE_DP) {
				const subtypeFieldValue = this.getFieldValue(this.SUBTYPE);
				const dptQuery = new Query().Attr("Active", "EQ", true).Attr("TemplateType", "EQ", `DataPackageContainerType:${xml.enumGetText(this.getFieldValue("RequestType"))}`);
				if (Sourcing.filterDPTFalseSupplierSpecific(subtypeFieldValue) && subtypeFieldValue !== csi.EMPTY_URL) {
					dptQuery.Attr("IsSupplierSpecific", "EQ", false);
				} else if(Sourcing.filterDPTTrueSupplierSpecific(subtypeFieldValue) && subtypeFieldValue !== csi.EMPTY_URL) {
					dptQuery.Attr("IsSupplierSpecific", "EQ", true);
				}
				const rel = lang.mixin(new Relationship(), {
					m_typeNode: "DataPackageTemplate",
					m_query: dptQuery
				});

				const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "DataPackageTemplates",
						m_url: "centric://APPAREL/SizeChartAdmin"
					}),
					m_fixedQuery: dptQuery
				});

				const srdpStore = new Names(storeOptions);
				srdpStore.put(csiStore.nameObject(""));
				return srdpStore;
			} else if (name == this.SUPPLIERS && this.isCopy()) {
				let search = new Search();
				search.setLimitPath(this.urlRoot, "Child:SRSuppliers");
				search.getQuery().Node("Type", "EQ", "Supplier");
				search.getSortQuery().SortByNode(xml.PROP_NAME);
				let priorityStore;
				let templateUrl = this.getFieldValue(this.TEMPLATE);
				if (xml.isValidURL(templateUrl)) {
					priorityStore = new Names({
						request: search.getRequest()
					});
					search = new Search();
					search.setLimitPath(templateUrl, "Child:SRTSuppliers");
					search.getQuery().Node("Type", "EQ", "Supplier");
					search.getSortQuery().SortByNode(xml.PROP_NAME);
				}

				const supplierStore = new Names({
					priorityStore: priorityStore,
					treatAsPriority: true,
					request: search.getRequest()
				});

				// Add Go to Dialog action.
				supplierStore.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "Suppliers",
						m_url: this.urlRoot
					})
				});
				return supplierStore;
			} else {
				return this.inherited(arguments);
			}
		},

		_buildView: function() {
			// summary: populate default and fixed values
			this.defView.m_formData.m_fAggregateSelected = lang.hitch(this, this._isTemplateSupplier);

			this.inherited(arguments);

			this.handleFactoryDirectDevelopment();
		},

		/*
		 * @override
		 * pre-populate Styles / Materials from original SR
		 */
		onViewStart: function(dfds) {
			this.inherited(arguments);

			const self = this;
			const productType = this._productType();
			if (this.isCopy()) {
				let search = new Search();
				search.byType(productType);
				search.setLimitPath(this.urlRoot, "Child:LineItems/Child:SRLineItemProduct");

				this.originalProductStore = new Names({
					typeNode: productType,
					request: search.getRequest()
				});

				// Add Go to Dialog action.
				this.originalProductStore.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						// based on what the productType is, load either SupplierRequestStyles|SupplierRequest or
						// SupplierRequestMaterials|SupplierRequest view for Style selection when a SupplierRequest
						// is copied
						m_id: "SupplierRequest" + productType + "s",
						m_url: this.urlRoot
					})
				});

				const idProperty = this.originalProductStore.idProperty;

				dfds.push(this.originalProductStore.query().then(function(results) {
					const idPropertyList = _.pluck(results, idProperty);
					if (idPropertyList.includes("Empty_All Items")) {
						self.addDefaultValue(productType + "s", []);
					} else {
						self.addDefaultValue(productType + "s", idPropertyList);
					}
				}));

				self.addDefaultValue(this.QUOTES, this.quoteSampleOptionPrevious);
				self.addDefaultValue(this.SAMPLES, this.quoteSampleOptionPrevious);
			}

			const request = new PostRequest("Sourcing", "GetSupplierSourcesWithReadAccess");
			request.addParameter("URL", this.urlRoot);

			dfds.push(request.go().then(function(response) {
				const results = response.getUrls();
				self.accessibleSupplierSources = results;
				if (self.isCopy()) {
					if(Sourcing.isFDDEnabled(self.getViewNode(),self.cacheView)) {
						self.getFormData().setFieldInitialValue(self.SUPPLIER_FACTORIES, _.intersection(self.getViewNode().SRSupplierFactories, results));
					} else {
						self.getFormData().setFieldInitialValue(self.SUPPLIERS, _.intersection(self.getViewNode().SRSuppliers, results));
					}
				}
			}));
		},

		/**
		 * @override
		 * hide the InspirationStyleType field conditionally
		 */
		_updateFieldVisibility (field) {
			this.inherited(arguments);

			const { INSPIRATION_STYLE_TYPE, SUBTYPE, REQUEST_TYPE} = this;
			if (field && field.getControlName() === SUBTYPE) {
				const requestType = xml.enumGetText(this.getFieldValue(REQUEST_TYPE));
				const subtypeUrl = this.getFieldValue(SUBTYPE);
				const isFDD = xml.isValidURL(subtypeUrl) && !Sourcing.isSubtypeSupplierSourced(subtypeUrl);

				const hideField = requestType !== "Style" || isFDD;

				this.setFieldHidden(INSPIRATION_STYLE_TYPE, hideField);
			}
		},

		_isTemplateSupplier: function(/*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: return true if supplier is stored in template
			const url = this.defView.getFieldValue(this.TEMPLATE);
			const t = this.cacheView.getNode(url);
			return t ? (array.indexOf(t.SRTSuppliers, ctx.getNodeURL()) >= 0) : false;
		},

		/**
		 * Subtype should be read only during copy
		 * @override
		 */
		isFieldEditable(field) {
			if (field.m_id == this.SUBTYPE && this.isCopy()) {
				return false;
			}

			return this.inherited(arguments);
		},

		/**
		 * Set query filter for hierarchy level base on parent node type
		 * @param parent - The parent node
		 * @param productQuery - query to add filter to
		 * @returns {Query}
		 */
		setProductStoreHierarchyLevelQuery(parent,productQuery) {
			const parentType = parent.$Type;
			// map of parent node types to which attribute on Style/Material maps to that parent
			const typeAttrMap = {
				"Collection": "Collection",
				"Category2": "Category2",
				"Category1": "Category1",
				"Season": "ParentSeason"
			};

			if (Object.keys(typeAttrMap).indexOf(parentType) != -1) {
				productQuery.RefAttr(typeAttrMap[parentType], xml.OP_EQUALS, parent.$URL);
			}
		},

		getProductsStore: function(productType) {
			if (this.isCopy()) {
				return this.originalProductStore;
			}

			const ac = this.defView.getSource();
			const parent = ac.getParent() || ac.getNode();
			const parentType = parent.$Type;
			const productQuery = new Query();

			this.setProductStoreHierarchyLevelQuery(parent, productQuery);

			// filter out Style template / special Material
			if (productType == "Style") {
				productQuery.Attr("IsTemplate", xml.OP_EQUALS, false);
				productQuery.Node(xml.PROP_FG, xml.OP_BIT_0, xml.NODE_FLAG_FROZEN);
			} else if (productType == "Food" || productType == "FormulatedMaterial") {
				productQuery.Node(xml.PROP_FG, xml.OP_BIT_0, xml.NODE_FLAG_FROZEN);
			} else if (productType == "FoodSKU") {
				productQuery.Node(xml.PROP_FG, xml.OP_BIT_0, xml.NODE_FLAG_FROZEN);
				productQuery.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, parent.$URL);
			} else {
				productQuery.Attr("Hidden", xml.OP_EQUALS, false);
				productQuery.Attr("Special", xml.OP_EQUALS, false);
				if (parentType == "MaterialSecurityGroup") {
					productQuery.RefAttr("MaterialSecurityGroups", xml.OP_EQUALS, parent.$URL);
				}
			}

			//Exclude FoodSKU from this filter because FoodSKU doesnt have subtype as an attribute
			if (productType != "FoodSKU") {
				this.addFilterByCreationLevel(productQuery);
			}

			const rel = lang.mixin(new Relationship(), {
				m_typeNode: productType,
				m_query: productQuery,
			});

			let viewUrl = "centric://APPAREL/Views";
			if (productType === "Food" || productType === "FormulatedMaterial" || productType === "FoodSKU") {
				viewUrl = "centric://REFLECTION/INSTANCE/_CS_Data/null"
			}
			const storeOptions = this.getProductStoreOptions(rel);
			// Add Go to Dialog action
			storeOptions.action = lang.mixin(new Action(), {
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "All" + productType + "s",
					m_url: viewUrl
				}),
				m_fixedQuery: productQuery
			});
			
			// make sure current value(s) are in store so it does not have to be queried
			return new Names(storeOptions); 
		},

		/**
		 * get product store options
		 * @param {String} rel - Relationship name
		 * @returns {Object} productStoreOptions
		 */
		getProductStoreOptions(rel) {
			return csiStore.namesOptionsByRelationship(this.getContext(), rel);
		},

		/**
		 * @override
		 * Set SRLineItemProduct on a fake new SRLineItem for aggregateStore filtering
		 */
		onWriteFormReport(field, writer, formInfo) {
			const {nodeUrl, contextUrl, sourceNodeUrl} = formInfo;
			const {cacheView} = this;
			const source = cacheView.getNode(sourceNodeUrl || contextUrl);
			const rc = reflection.getNodeClass(source);
			if(rc?.isDerivedFrom("BaseProduct")) {
				const srLineItemUrl = xml.getClientNodeUrl();
				writer.createNode(srLineItemUrl, "SRLineItem")
					.attach(nodeUrl, "LineItems")
					.changeAttribute("SRLineItemProduct", xml.ATTR_REF, contextUrl);
			} 
			if (source?.$Type !== "SupplierRequestMaster") {
				writer.changeNode(nodeUrl)
					.publishAttribute("HierarchyLevel", xml.ATTR_REF, contextUrl);
			}
		},

		_onChangeIncludeSamples: function(/*csi.form.View*/formView, /*csi.def.Field*/f, /*Any*/value) {
			this._updateStatistics();
		},

		_onChangeIncludeQuotes: function(/*csi.form.View*/formView, /*csi.def.Field*/f, /*Any*/value) {
			this._updateStatistics();
		},

		_onChangeProducts: function(/*csi.form.View*/formView, /*csi.def.Field*/f, /*Any*/value) {
			// every change on styles/materials needs to update the sidebar
			this._updateStatistics();
		},

		/**
		 * Display warning message when changing data package template
		 */
		_onChangeDPTemplate: function(formView, f, value) {
			this.invalidNode.set("icon", this.invalidNode.WARNING);
			const node = this.getContext().getNode();
			if (node && node.LineItems && node.LineItems.length > 0) {
				this.invalidNode.set("value", locale.resource("ChangeDPTemplateOrSuppliers_Warning"));
			}
		},

		/**
		 * Display warning message when changing supplier/factories and data package template is supplier specific
		 */
		_onChangeSuppliersOrFactories: function(formView, f, value) {
			// every change on suppliers needs to update the sidebar
			this._updateStatistics();

			const node = this.getContext().getNode();
			if (node && node.LineItems && node.LineItems.length > 0) {
				this.invalidNode.set("icon", this.invalidNode.WARNING);
				this.invalidNode.set("value", locale.resource("ChangeDPTemplateOrSuppliers_Warning"));
			}
		},

		_onChangeTemplate: function(/*csi.form.View*/formView, /*csi.def.Field*/f, /*Any*/value) {
			// Check whether or not template value is "" or 'centric:'
			// if there is no template value, exit function to avoid template form logic on a null template
			if (!xml.isValidURL(value)) {
				let [field, srcNodes] = this.getSRTemplatePrimarySources(null, formView);
				if (field) {
					if (this.isCopy()) {
						// update Supplier Template Form with default values on copy
						this.setFieldValue(this.QUOTES, 1);
						this.setFieldValue(this.SAMPLES, 1);
						this.setFieldDisabled(this.QUOTES, true);
						// vet out the suppliers/supplierFactories you can't see by intersecting srcNodes with accessibleSupplierSources
						_.intersection(this.getViewNode().SRSuppliers, this.accessibleSupplierSources)
						if(Sourcing.isFDDEnabled(this.getViewNode(),this.cacheView)) {
							srcNodes = _.intersection(this.getViewNode().SRSupplierFactories, this.accessibleSupplierSources);
						} else {
							srcNodes = _.intersection(this.getViewNode().SRSuppliers, this.accessibleSupplierSources);
						}
						this.resetFieldStoreAndValue(field, srcNodes);
					} else {
						if (this._productType() == "Food") {
							this.setFieldValue(field, this.getDefaultValue(field) || []);
						} else {
							this.setFieldValue(field, []);
						}
					}
				}

				if (f = formView.getField(this.INSPIRATION_STYLE_TYPE)) {
					this.setFieldValue(f, csi.EMPTY_URL);
				}

				if (f = formView.getField(this.QUOTES)) {
					this.setFieldValue(f, this.quoteSampleOptionPrevious);
				}

				if (f = formView.getField(this.SAMPLES)) {
					this.setFieldValue(f, this.quoteSampleOptionPrevious);
				}

				if (f = formView.getField(this.TEMPLATE_DP)) {
					this.setFieldValue(f, csi.EMPTY_URL);
				}

			} else {
				// summary: update fields based on template
				this.cacheView.getNodeDeferred(value).then(function(template) {
					this.setFieldDisabled(this.QUOTES, false);
					const fd = this.defView.m_formData;

					fd.resetAggregations();
					fd.resetSelections();
					const [field, srcNodes] = this.getSRTemplatePrimarySources(template, formView);
					if (field) {
						if (srcNodes && srcNodes.length > 0) {
							// vet out the suppliers you can't see by intersecting template.SRTSuppliers/template.SRTSupplierFactories with accessibleSupplierSources
							const accessibleTemplateSupplierSources = _.intersection(srcNodes, this.accessibleSupplierSources)
							this.resetFieldStoreAndValue(field, accessibleTemplateSupplierSources);

							if (this.isCopy()) {
								this.resetFieldStoreAndValue(field, accessibleTemplateSupplierSources);
							} else {
								const self = this;
								const fieldStore = field.m_control.store;

								when(fieldStore.query(), function(results) {
									// filter supplier/supplierFactories default value as supplier default values from node may not be present in the field store due to role accessibility
									const ids = _.map(results, fieldStore.getIdentity, fieldStore);
									const value = _.intersection(ids, accessibleTemplateSupplierSources);
									self.setFieldValue(field.m_id, value, true);
								});
							}
						} else if (this._productType() == "Food") {
							this.setFieldValue(this.SUPPLIERS, this.getDefaultValue(this.SUPPLIERS) || []);
						}
					}

					if ((f = formView.getField(this.TEMPLATE_DP)) && xml.isValidURL(template.SRTDPTemplate)) {
						this.setFieldValue(f, template.SRTDPTemplate, true);
					}

					if ((f = formView.getField(this.NOTIFY_GROUPS)) && template.SRNotifyGroups.length > 0) {
						this.setFieldValue(f, template.SRNotifyGroups, true);
					}

					if (f = formView.getField(this.INSPIRATION_STYLE_TYPE)) {
						this.setFieldValue(f, template.InspirationStyleType, true);
					}

					if (f = formView.getField(this.SUBMIT_TO_WORKFLOW)) {
						this.setFieldValue(f, template.SubmitQuotesToWF, true);
					}

					if (f = formView.getField(this.QUOTES)) {
						this.setFieldValue(f, this.quoteSampleOptionTemplate, true);
					}

					if (f = formView.getField(this.SAMPLES)) {
						this.setFieldValue(f, this.quoteSampleOptionTemplate, true);
					}

					if (f = formView.getField(this.SAMPLETYPE)) {
						this.setFieldValue(f, template.SampleType, true);
					}

				}.bind(this));
			}

			// every change on template needs to update the side panel
			this._updateStatistics();
		},

		/**
		 * Show/Hide Supplier and Supplier Factory fields based on feature toggle
		 */
		handleFactoryDirectDevelopment() {
			this._onChangeSubtype(null, null, this.getFieldValue(this.SUBTYPE));
		},

		/**
		 * Show/Hide Supplier and Supplier Factory fields based on SR Subtype
		 * @param {View} defView
		 * @param {Field} field
		 * @param {String} value
		 */
		_onChangeSubtype(defView, field, value) {
			const newType = Sourcing.filterDPTTrueSupplierSpecific(value) ? xml.ATTR_REF : xml.ATTR_REFLIST;
			const newTypeControl = Sourcing.filterDPTTrueSupplierSpecific(value) ? def.FIELD_FILTERING_SELECT : def.FIELD_MULTI_SELECT;
			const dps_path = xml.path("ProductSourcing", "DesignatedProductSource", "Supplier");
			const dps_path_fdd = xml.path("ProductSourcing", "DesignatedProductSource", "SupplierFactory");
			const product = this.defView.getSource().getParent();
			const isFDDEnabled = Sourcing.isFDDEnabled(product, this.cacheView)
			const dpsPathToUse = isFDDEnabled ? dps_path_fdd : dps_path;
			const dps = this.getCache().getPathNode(product, dpsPathToUse);
			this.resetFieldStoreAndValue(this.TEMPLATE, this.TEMPLATE_VALUE);
			this.resetProductFieldBySubtype(value);
			if(!xml.isValidURL(value)) {
				this.showSupplierOrFactoryBaseOnFixedProduct();
			} else if(Sourcing.isSubtypeSupplierSourced(value)) {
				const suppliersField = this.defView.getField(this.SUPPLIERS);
				suppliersField.m_typeControl = newTypeControl;
				suppliersField.m_type = newType;
				this._rebuildField(suppliersField);
				this.setFieldHidden(this.SUPPLIERS, false);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
				this.rightWidget?.useSupplierOrFactoryNodes(true, false);
			} else {
				const suppliersFactoryField = this.defView.getField(this.SUPPLIER_FACTORIES);
				suppliersFactoryField.m_typeControl = newTypeControl;
				suppliersFactoryField.m_type = newType;
				this._rebuildField(suppliersFactoryField);
				this.setFieldHidden(this.SUPPLIERS, true);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, false);
				this.rightWidget?.useSupplierOrFactoryNodes(false, true);
			}
			this.currentCreationLevel = config.getSubtypeSetting(value, this.PRODUCT_SOURCE_CREATION_LEVEL);

			if (this.isNew()) {
				this.resetFieldStoreAndValue(this.TEMPLATE_DP, csi.EMPTY_URL);
				this.resetFieldStoreAndValue(this.SUPPLIERS);
				this.resetFieldStoreAndValue(this.SUPPLIER_FACTORIES);
				this.setFieldValue(this.SUPPLIERS, newTypeControl === def.FIELD_MULTI_SELECT ? [] : csi.EMPTY_URL);
				this.setFieldValue(this.SUPPLIER_FACTORIES, newTypeControl === def.FIELD_MULTI_SELECT ? [] : csi.EMPTY_URL);
				if (dps && isFDDEnabled) {
					this.setFieldValue(this.SUPPLIER_FACTORIES, newTypeControl === def.FIELD_MULTI_SELECT ? [dps.$URL] : dps.$URL);
				} else if (dps && !isFDDEnabled) {
					this.setFieldValue(this.SUPPLIERS, newTypeControl === def.FIELD_MULTI_SELECT ? [dps.$URL] : dps.$URL);
				}
			}
			this._updateStatistics();
		},

		/**
		 * Show/Hide Supplier and Supplier Factory fields based on Fixed Product
		 */
		showSupplierOrFactoryBaseOnFixedProduct() {
			const ProductSourceCreationLevel = this.getProductSourceCreationLevelByFixedProduct();
			if(ProductSourceCreationLevel === "ProductSourceCreationLevel:Supplier"){
				this.setFieldHidden(this.SUPPLIERS, false);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
				this.rightWidget?.useSupplierOrFactoryNodes(true, false);
			} else if(ProductSourceCreationLevel === "ProductSourceCreationLevel:Factory") {
				this.setFieldHidden(this.SUPPLIERS, true);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, false);
				this.rightWidget?.useSupplierOrFactoryNodes(false, true);
			} else {
				this.setFieldHidden(this.SUPPLIERS, true);
				this.setFieldHidden(this.SUPPLIER_FACTORIES, true);
				this.rightWidget?.useSupplierOrFactoryNodes(false, false);
			}
		},

		getSRTemplatePrimarySources(templateNode, formView) {
			let scrField = formView.getField(this.SUPPLIERS);
			const subtype = this.getFieldValue(this.SUBTYPE);
			if(Sourcing.isSubtypeSupplierSourced(subtype)) {
				return [scrField, templateNode ? templateNode.SRTSuppliers : []];
			} else {
				scrField = formView.getField(this.SUPPLIER_FACTORIES);
				return [scrField, templateNode ? templateNode.SRTSupplierFactories : []];
			}
		},

		/**
		 * Reset Product field when SR Subtype or Fixed Product is changed
		 * @param {String} value
		 */
		resetProductFieldBySubtype(value) {
			const creationLevel = config.getSubtypeSetting(value, this.PRODUCT_SOURCE_CREATION_LEVEL);
			// If it is creating a new supplier request, the field value is fixed.
			const productsFieldName = this._productType() + "s";
			const productValue = this.isCopy() ? this.getFieldValue(productsFieldName) : this.getFixedValue(productsFieldName);
			if(this.currentCreationLevel !== creationLevel && !productValue) {
				this.resetFieldStoreAndValue(productsFieldName, this.srMaster?.SRMProducts);
			}
		},

		/**
		 * Get Product Source Creation Level by Fixed Product
		 * @returns {String} ProductSourceCreationLevel
		 */
		getProductSourceCreationLevelByFixedProduct() {
			const productFixedValue = this.getFixedValue(this._productType() + "s");
			const ProductSourceCreationLevel = Sourcing.getProductSourceCreationLevel(productFixedValue, this.getCache());
			return ProductSourceCreationLevel;
		},

		/**
		 * Add filter by By Product or SR Subtype creation level
		 * @param {Query} productQuery
		 */
		addFilterByCreationLevel(productQuery) {
			const productType = this._productType();
			const subtypeFieldValue = this.getFieldValue(this.SUBTYPE);
			let creationLevel = this.getProductSourceCreationLevelByFixedProduct();
			if (!creationLevel && xml.isValidURL(subtypeFieldValue)) {
				creationLevel = config.getSubtypeSetting(subtypeFieldValue, this.PRODUCT_SOURCE_CREATION_LEVEL);
			}

			if (creationLevel) {
				if (productType === 'Material' || productType === 'Style') {
					productQuery.Attr(this.PRODUCT_SOURCE_CREATION_LEVEL, xml.OP_EQUALS, creationLevel, "Child:ProductType/Child:ProductionConfig");
				} else {
					productQuery.Attr(this.PRODUCT_SOURCE_CREATION_LEVEL, xml.OP_EQUALS, creationLevel, "Child:Subtype/Child:Settings");
				}
			}
		},

		/** should be implemented by child controllers */
		_updateStatistics() {
		}
	});
});
